module.exports = __webpack_public_path__ + "img/bg.d62d8df5.png";